window.indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.OIndexedDB || window.msIndexedDB,
    IDBTransaction = window.IDBTransaction || window.webkitIDBTransaction || window.OIDBTransaction || window.msIDBTransaction;

export default class IndexDBService {

  #db;
  get db() {
    return this.#db;
  }
  
  #storeName = 'localFiles';
  #storeKey = 'name';
  #dbVersion = 1;

  constructor() {
  }

  async init() {
    this.#db = await this.#initIndexedDb('iong-db', [{ name: this.#storeName, keyPath: this.#storeKey }]);
    return;
  }

  #initIndexedDb(dbName, stores)  {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(dbName, this.#dbVersion);
      request.onerror = (event) => {
        reject(event.target.error);
      };
      request.onsuccess = (event) => {
        resolve(event.target.result);
      };
      request.onupgradeneeded = (event) => {
        stores.forEach((store) => {
          const objectStore = event.target.result.createObjectStore(store.name, {
            keyPath: store.keyPath,
          });
          objectStore.createIndex(store.keyPath, store.keyPath, { unique: true });
        });
      };
    });
  }

  addFile(file, overwrite = true) {
    const store = this.#db.transaction(this.#storeName, 'readwrite').objectStore(this.#storeName);
	  const keyRequest = store.getKey(file.name);
    return new Promise ((resolve, reject) => {
      keyRequest.onsuccess = (e) => {
        let request
        if (!e.target.result) {
          request = store.add(file);
        } else {
          if (overwrite) {
            request = store.put(file);
          } else {
            reject(`Key, ${file.name}, already exists in DB.`);
          }
        }
        request.onsuccess = (e) => {
          resolve(e.target.result);
        }
        request.onerror = (e) => {
          reject(e.target.error);
        }
      }
      keyRequest.onerror = (e) => {
        reject(e.target.error);
      }
    });
  }

  getKey(key) {
    const store = this.#db.transaction(this.#storeName, 'readonly').objectStore(this.#storeName);
    const request = store.getKey(key)
    return new Promise ((resolve, reject) => {
      request.onsuccess = (e) => {
        resolve(e.target.result);
      }
      request.onerror = (e) => {
        reject(e.target.error);
      }
    });
  }

  getFile(key) {
    const store = this.#db.transaction(this.#storeName, 'readonly').objectStore(this.#storeName);
    const request = store.get(key)
    return new Promise ((resolve, reject) => {
      request.onsuccess = (e) => {
        resolve(e.target.result);
      }
      request.onerror = (e) => {
        reject(e.target.error);
      }
    });
  }

  deleteFile(key) {
    const store = this.#db.transaction(this.#storeName, 'readwrite').objectStore(this.#storeName);
	  const request = store.delete(key);
    return new Promise ((resolve, reject) => {
      request.onsuccess = (e) => {
        resolve(e.target.result);
      }
      request.onerror = (e) => {
        reject(e.target.error);
      }
    });
  }

  clear() {
    const store = this.#db.transaction(this.#storeName, 'readwrite').objectStore(this.#storeName);
	  const request = store.clear();
    return new Promise ((resolve, reject) => {
      request.onsuccess = (e) => {
        resolve(e.target.result);
      }
      request.onerror = (e) => {
        reject(e.target.error);
      }
    });
  }

}